import { newEntryKey, routerEntry, SECTION_PATH } from '@/lib/bookNavigation';

/**
 * Runs once, before the router reads the URL. A section opened as a fresh
 * entry (a cold link, a new tab; not a refresh, which keeps the router's
 * `idx`) gets its document written behind it, so Back shows the document at
 * the section's row (§3.3). The app restores scroll itself (`lib/landing`),
 * so the browser's own pixel restoration is switched off.
 */
export function seedHistory(win: typeof window = window): void {
  win.history.scrollRestoration = 'manual';
  if (win.history.state?.idx != null) return;
  const { pathname, search, hash } = win.location;
  const section = SECTION_PATH.exec(pathname);
  // Every fresh entry gets a key of its own: the router would call each one `default`, and a place remembered for one would land another.
  if (!section) {
    if (!win.history.state?.key) win.history.replaceState({ ...(win.history.state ?? {}), key: newEntryKey() }, '');
    return;
  }
  const docPath = `/d/${section[1]}`;
  win.history.replaceState(routerEntry({ land: { section: decodeURIComponent(section[2]!) } }, 0), '', docPath);
  win.history.pushState(routerEntry({ from: docPath }, 1), '', `${pathname}${search}${hash}`);
}
